import VisitaEcg from "./visitaecg/index"

export default {
    VisitaEcg
}